require('./_typed-array')('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es6.typed.int16-array.js
// module id = 530
// module chunks = 0